module.exports = __webpack_public_path__ + "img/masterCard-light.3b2d6e2f.svg";